export interface BuscarRemetenteDIViewModel {
	fornecedoresClientes: RemetenteImportacaoViewModel[];
	adquirenteEncomendanteID?: number;
	adquirenteEncomendanteCNPJ?: string;
	adquirenteEncomendanteNome?: string;
}

export interface RemetenteImportacaoViewModel {
	id: number;
	razaoSocial: string;
	endereco: string;
	numero?: number;
	bairro: string;
	paisId?: number;
	complemento: string;
	comexSeparadorCodigoProduto: string
}